import { AnnouncementFeedbackModel } from "./announcement-feedback";

export class AnnouncementFeedbackExport {
  
  Announcement_Title: string;
  Request_Number: string;
  Tenant: string;
  Feedback_Date: string;
  Feedbak_By: string;
  Feedback: string;

  constructor(request: AnnouncementFeedbackModel) {
    this.Announcement_Title = request.announcementTitle;
    this.Request_Number = request.requestNumber;
    this.Tenant = request.companyName;
    this.Feedback_Date = typeof request.feedbackDate == "object" ? request.feedbackDate.toLocaleDateString() : new Date(request.feedbackDate).toLocaleDateString();
    this.Feedbak_By = request.createdBy;
    this.Feedback = request.feedbackNotes;
    
    //console.log(this.Feedback_Date);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/announcement-feedback-export.ts